<template>
  <div class="page">
    <el-form label-width="100px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="关键字:">
            <el-input v-model="queryForm.Keyword" placeholder="请输入昵称或登录名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="状态：">
            <el-select v-model="queryForm.IsActive" class="w100">
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="true" label="正常"></el-option>
              <el-option :value="false" label="禁用"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div class="flex">
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="empty">重置</el-button>
          <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <el-table :data="userList" highlight-current-row v-loading="tableLoading" @current-change="selectCurrentRow"
      style="width: 100%" border>
      <el-table-column prop="userName" label="登录名" min-width="100" align="center"></el-table-column>
      <el-table-column prop="phoneNumber" label="手机号" min-width="100" align="center"></el-table-column>
      <el-table-column prop="name" label="昵称" min-width="100" align="center"></el-table-column>
      <el-table-column prop="emailAddress" label="邮箱" min-width="180" align="center"></el-table-column>
      <el-table-column prop="isActive" label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isActive ? 'success' : 'danger'" disable-transitions>{{ scope.row.isActive ? "正常" :
            "禁用"
            }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="lastLoginTime" label="上次登录时间" min-width="180" align="center"></el-table-column>
      <el-table-column prop="creationTime" label="创建时间" min-width="180" align="center"></el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" :total="total"
      :current-page="queryForm.pageIndex" :pageSize="queryForm.pageSize" @current-change="handleCurrentChange"
      @size-change="handleSizeChange"></el-pagination>
    <el-dialog :title="isEdit ? '编辑' : '新增'" :visible.sync="userFormVisible" v-if="userFormVisible"
      v-model="userFormVisible" :close-on-click-modal="false">
      <el-form :model="userForm" label-width="120px" :rules="userFormRules" ref="userForm">
        <el-form-item label="登录名" prop="userName">
          <el-input v-model="userForm.userName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input v-model="userForm.phoneNumber" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="name">
          <el-input v-model="userForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="isEdit == false">
          <el-input v-model="userForm.password" show-password auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="emailAddress">
          <el-input v-model="userForm.emailAddress"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="isActive">
          <el-select v-model="userForm.isActive">
            <el-option label="正常" :value="true"></el-option>
            <el-option label="禁用" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="userFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitUser" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="分配角色" :visible.sync="setRolesDialog" v-if="setRolesDialog" v-model="setRolesDialog"
      :close-on-click-modal="false">
      <template>
        <el-transfer :props="{
          key: 'normalizedName',
          label: 'displayName'
        }" v-model="userForm.roleNames" filterable :titles="['待分配角色', '已分配角色']" :format="{
          noChecked: '${total}',
          hasChecked: '${checked}/${total}'
        }" :data="roleList">
        </el-transfer>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="setRolesDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitRoles" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetAllUser,
  CreateUser,
  GetUserDetail,
  UpdateUser,
  DeleteUser,
  GetRoles
} from "../../api/api";
import toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
export default {
  components: { toolbar },
  data() {
    const validatePwd = (rule, value, callback) => {
      // if (!/^[a-zA-Z]\w{5,17}$/.test(value)) {
      //   callback(new Error('密码必须以字母开头，长度在6~18之间，只能包含字母、数字和下划线'))
      // }
      if (!/^\w{8,16}$/.test(value)) {
        callback(new Error('密码长度8到16位，只能包含字母、数字和下划线'))
      }
      callback()
    }
    return {
      buttonList_toolBar: [],

      userList: [],
      tableLoading: false,
      currentRow: null,
      total: 0,
      queryForm: {
        Keyword: null,
        IsActive: null,
        pageIndex: 1,
        pageSize: 10
      },

      userFormVisible: false,
      isEdit: false,
      userForm: {
        userName: null,
        phoneNumber: null,
        name: null,
        surname: null,
        password: null,
        emailAddress: null,
        isActive: true,
        roleNames: []
      },
      userFormRules: {
        userName: [
          { required: true, message: '请输入登录名', trigger: 'blur' },
          { message: '请输入登录名', trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { message: '请输入昵称', trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { trigger: ['blur', 'change'], validator: validatePwd, }
        ],
        emailAddress: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
      },
      submitLoading: false,

      setRolesDialog: false,
      roleList: []
    };
  },
  mounted() {
    this.getUserList();
    this.getRolesList();
    this.renderButton();
  },
  methods: {
    renderButton() {
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    getUserList() {
      this.tableLoading = true;
      let params = {
        Keyword: this.queryForm.Keyword,
        IsActive: this.queryForm.IsActive,
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      GetAllUser(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.userList = res.data.result.items;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.queryForm.pageIndex = val;
      this.getUserList();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getUserList();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getUserList();
    },
    empty() {
      this.queryForm.Keyword = null;
      this.queryForm.IsActive = null;
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getUserList();
    },
    addUser() {
      this.userFormVisible = true;
      this.isEdit = false;
      this.userForm = {
        userName: null,
        phoneNumber: null,
        name: null,
        surname: null,
        password: null,
        emailAddress: null,
        isActive: true,
        roleNames: []
      }
    },
    editUser() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要编辑的一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      GetUserDetail(params).then((res) => {
        if (res.data.success) {
          that.userForm = res.data.result;
          that.isEdit = true;
          that.userFormVisible = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    delUser() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要删除的一行数据！');
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = { Id: row.id };
        let that = this;
        DeleteUser(params).then((res) => {
          that.tableLoading = false;
          if (res.data.success) {
            that.$message.success('删除成功');
            that.getUserList();
          } else {
            that.$message.error(res.data.msg);
          }
        });
      }).catch(() => { });
    },
    submitUser() {
      let that = this;
      that.$refs.userForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            if (!that.isEdit) {
              // surname必填且不能为空、不能为空字符串。。。
              that.userForm.surname = that.userForm.name;
              CreateUser(that.userForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('新增成功');
                  that.userFormVisible = false;
                  that.getUserList();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              UpdateUser(that.userForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('修改成功');
                  that.userFormVisible = false;
                  that.getUserList();
                } else {
                  that.$message.error(res.data.error.message)
                }
              });
            }
          }).catch(() => { });
        }
      });
    },
    getRolesList() {
      let that = this;
      GetRoles().then((res) => {
        that.roleList = res.data.result.items;
      });
    },
    setRoles() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      GetUserDetail(params).then((res) => {
        if (res.data.success) {
          that.userForm = res.data.result;
          that.setRolesDialog = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    submitRoles() {
      this.$confirm("确认提交吗？", "提示", {
        closeOnClickModal: false,
      }).then(() => {
        this.submitLoading = true;
        let that = this;
        UpdateUser(that.userForm).then((res) => {
          that.submitLoading = false;
          if (res.data.success) {
            that.$message.success('提交成功');
            that.setRolesDialog = false;
          } else {
            that.$message.error(res.data.error.message)
          }
        });
      }).catch(() => { });
    }
  }
};
</script>
<style scoped>
#main-box {
  width: 100%;
  height: 100%;
  padding-top: 90px;
}

#btn-box {
  position: fixed;
  height: 110px;
  top: 94px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  padding-top: 5px;
}

#btn-box /deep/ .el-form-item {
  margin-bottom: 10px;
}

#content-box {
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

#main-box /deep/ .el-pagination {
  padding: 10px 5px;
}


.tool_box {
  padding-top: 20px;
  overflow: hidden;
}
</style>
